/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SiteSortimentEntryResponseModel } from '../../models/site-sortiment-entry-response-model';

export interface GetSortimentEntryById$Params {

/**
 * UUID of the site-level sortiment entry (productSortimentEntryId)
 */
  sortimentEntryId: string;
}

export function getSortimentEntryById(http: HttpClient, rootUrl: string, params: GetSortimentEntryById$Params, context?: HttpContext): Observable<StrictHttpResponse<SiteSortimentEntryResponseModel>> {
  const rb = new RequestBuilder(rootUrl, getSortimentEntryById.PATH, 'get');
  if (params) {
    rb.path('sortimentEntryId', params.sortimentEntryId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SiteSortimentEntryResponseModel>;
    })
  );
}

getSortimentEntryById.PATH = '/sortiment/{sortimentEntryId}';
